// src/utils/formatters.js
/**
 * Utilidades para formateo de datos
 */

/**
 * Formatea un RUT con puntos y guión
 * @param {string} rut - RUT sin formato
 * @param {string} dv - Dígito verificador
 * @returns {string} - RUT formateado
 */
export const formatearRut = (rut, dv) => {
    if (!rut) return '';
    return `${rut.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}-${dv || ''}`;
  };
  
  /**
   * Formatea un monto como moneda chilena
   * @param {number} monto - Monto a formatear
   * @returns {string} - Monto formateado
   */
  export const formatearMonto = (monto) => {
    if (monto === null || monto === undefined) return '';
    return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(monto);
  };
  
  /**
   * Formatea una fecha a formato local
   * @param {string|Date} fecha - Fecha a formatear
   * @returns {string} - Fecha formateada
   */
  export const formatearFecha = (fecha) => {
    if (!fecha) return '';
    const date = new Date(fecha);
    return date.toLocaleDateString('es-CL');
  };
  
  /**
   * Obtiene la etiqueta para un tipo de documento
   * @param {string} tipo - Código de tipo de documento
   * @returns {string} - Etiqueta del tipo de documento
   */
  export const getTipoDocLabel = (tipo) => {
    const tiposDoc = {
      '30': 'Factura',
      '33': 'Factura Electrónica',
      '34': 'Factura Exenta Electrónica',
      '39': 'Boleta Electrónica',
      '41': 'Boleta Exenta Electrónica',
      '56': 'Nota Débito Electrónica',
      '61': 'Nota Crédito Electrónica',
      '110': 'Factura de exportación',
      '111': 'Nota débito de exportación',
      '112': 'Nota crédito de exportación'
    };
    return tiposDoc[tipo] || tipo;
  };